export let MENU_ITEMS = [
  {
    label: 'layout.private.menu.invoices',
    path: '/invoices',
    icon: require('../../../../resources/images/invoices_icon.svg').default,
  },
  {
    label: 'layout.private.menu.contracts',
    path: '/contracts',
    icon: require('../../../../resources/images/contracts_icon.svg').default,
  },
]

export let ATR_PLUS_MENU_ITEMS = [
  {
    label: 'layout.private.menu.invoices',
    path: '/invoices',
    icon: require('../../../../resources/images/invoices_icon.svg').default,
  },
  {
    label: 'layout.private.menu.contracts',
    path: '/contracts',
    icon: require('../../../../resources/images/contracts_icon.svg').default,
  },
  {
    label: 'layout.private.menu.users',
    path: '/users',
    icon: require('../../../../resources/images/users_icon.svg').default,
  },
]

export let DEFAULT_ROUTE = '/invoices'

export let PROFILE_ROUTE = '/account'

export let SETTINGS_ROUTE = '/settings'
